import { CrudModule, inr } from "@/command/ccCrud";

export default function Customers() {
  return (
    <CrudModule
      title="Customers" subtitle="Accounts, contacts and relationship value — live."
      module="customers" endpoint="/cc/customers" entity="customer" summaryPath="/cc/customers/summary"
      columns={[["name", "Customer"], ["contact", "Contact"], ["email", "Email"], ["industry", "Industry"], ["status", "Status", "badge"], ["value", "Value", "money"]]}
      fields={[["name", "Name", "text"], ["contact", "Contact person", "text"], ["email", "Email", "text"],
        ["industry", "Industry", "text"], ["status", "Status", "select", ["Prospect", "Active", "Churned"]], ["value", "Account value (₹)", "number"]]}
      defaults={{ status: "Prospect" }}
      kpis={(rows, s) => [
        { label: "Customers", value: s?.total ?? rows.length },
        { label: "Active", value: s?.active ?? 0 },
        { label: "Prospects", value: s?.prospects ?? 0 },
        { label: "Total Value", value: s?.value ?? 0, prefix: "₹" },
      ]}
    />
  );
}
